export var EntityType;
(function (EntityType) {
    EntityType["PLAYER"] = "player";
    EntityType["NPC"] = "npc";
    EntityType["ENEMY"] = "enemy";
})(EntityType || (EntityType = {}));
export var EntityStatus;
(function (EntityStatus) {
    EntityStatus["NORMAL"] = "normal";
    EntityStatus["DEAD"] = "dead";
    EntityStatus["UNCONSCIOUS"] = "unconscious";
})(EntityStatus || (EntityStatus = {}));
export var CharacterCreationStepEnum;
(function (CharacterCreationStepEnum) {
    CharacterCreationStepEnum["QUESTIONS"] = "questions";
    CharacterCreationStepEnum["APPEARANCE"] = "appearance";
    CharacterCreationStepEnum["ATTRIBUTES"] = "allocate-attributes";
    CharacterCreationStepEnum["SKILLS"] = "allocate-skills";
    CharacterCreationStepEnum["NAME"] = "name";
    CharacterCreationStepEnum["COMPLETE"] = "complete";
})(CharacterCreationStepEnum || (CharacterCreationStepEnum = {}));
export var AttributeEnum;
(function (AttributeEnum) {
    AttributeEnum["MIGHT"] = "might";
    AttributeEnum["AGILITY"] = "agility";
    AttributeEnum["RESOLVE"] = "resolve";
    AttributeEnum["INTELLECT"] = "intellect";
    AttributeEnum["CHARM"] = "charm";
})(AttributeEnum || (AttributeEnum = {}));
export var SkillEnum;
(function (SkillEnum) {
    SkillEnum["ATHLETICS"] = "athletics";
    SkillEnum["STEALTH"] = "stealth";
    SkillEnum["BUSHCRAFT"] = "bushcraft";
    SkillEnum["MELEE"] = "melee";
    SkillEnum["RANGED"] = "ranged";
    SkillEnum["SPELLCRAFT"] = "spellcraft";
    SkillEnum["LORE"] = "lore";
    SkillEnum["CRAFT"] = "craft";
    SkillEnum["HEALING"] = "healing";
    SkillEnum["GUILE"] = "guile";
    SkillEnum["INSIGHT"] = "insight";
    SkillEnum["PERCEPTION"] = "perception";
})(SkillEnum || (SkillEnum = {}));
export var EquipmentSlot;
(function (EquipmentSlot) {
    EquipmentSlot["NONE"] = "none";
    EquipmentSlot["HEAD"] = "head";
    EquipmentSlot["BODY"] = "body";
    EquipmentSlot["MAIN_HAND"] = "mainHand";
    EquipmentSlot["OFF_HAND"] = "offHand";
    EquipmentSlot["ACCESSORY"] = "accessory";
})(EquipmentSlot || (EquipmentSlot = {}));
// Where a consumable may be activated. Items are hidden (or greyed out) in the
// context that does not permit them.
export var ConsumableUseContext;
(function (ConsumableUseContext) {
    ConsumableUseContext["EXPLORATION"] = "exploration";
    ConsumableUseContext["COMBAT"] = "combat";
    ConsumableUseContext["ANY"] = "any";
})(ConsumableUseContext || (ConsumableUseContext = {}));
export var ItemLocationType;
(function (ItemLocationType) {
    ItemLocationType["UNKNOWN"] = "unknown";
    ItemLocationType["CHARACTER"] = "character";
    ItemLocationType["LOCATION"] = "location";
})(ItemLocationType || (ItemLocationType = {}));
export var NpcReputation;
(function (NpcReputation) {
    NpcReputation["ENAMOURED"] = "enamoured";
    NpcReputation["DEVOTED"] = "devoted";
    NpcReputation["ADORING"] = "adoring";
    NpcReputation["GRATEFUL"] = "grateful";
    NpcReputation["FRIENDLY"] = "friendly";
    NpcReputation["WARM"] = "warm";
    NpcReputation["TRUSTING"] = "trusting";
    NpcReputation["FOND"] = "fond";
    NpcReputation["RESPECTFUL"] = "respectful";
    NpcReputation["NEUTRAL"] = "neutral";
    NpcReputation["CURIOUS"] = "curious";
    NpcReputation["WARY"] = "wary";
    NpcReputation["ENVIOUS"] = "envious";
    NpcReputation["SUSPICIOUS"] = "suspicious";
    NpcReputation["DISTRUSTFUL"] = "distrustful";
    NpcReputation["CONTEMPTUOUS"] = "contemptuous";
    NpcReputation["RESENTFUL"] = "resentful";
    NpcReputation["FEARFUL"] = "fearful";
    NpcReputation["HOSTILE"] = "hostile";
    NpcReputation["WRATHFUL"] = "wrathful";
})(NpcReputation || (NpcReputation = {}));
/**
 * Machine-readable category for a relationship an NPC has with another character
 * (another NPC or the player). Drives narrative tone; an optional free-text `note`
 * carries the specific flavor (e.g. "the man who stole from my family").
 */
export var NpcCharacterRelation;
(function (NpcCharacterRelation) {
    NpcCharacterRelation["FAMILY"] = "family";
    NpcCharacterRelation["ALLY"] = "ally";
    NpcCharacterRelation["FRIEND"] = "friend";
    NpcCharacterRelation["RIVAL"] = "rival";
    NpcCharacterRelation["ENEMY"] = "enemy";
    NpcCharacterRelation["MENTOR"] = "mentor";
    NpcCharacterRelation["ACQUAINTANCE"] = "acquaintance";
})(NpcCharacterRelation || (NpcCharacterRelation = {}));
/**
 * Machine-readable category for a relationship an NPC has with a place. Drives
 * world-gen placement: `residence` co-locates the place on the NPC's hex; the rest
 * place the place independently (or not at all). See feature plan 31.
 */
export var NpcPlaceRelation;
(function (NpcPlaceRelation) {
    NpcPlaceRelation["RESIDENCE"] = "residence";
    NpcPlaceRelation["SEEKS"] = "seeks";
    NpcPlaceRelation["KNOWS_LOCATION"] = "knows_location";
    NpcPlaceRelation["FREQUENTS"] = "frequents";
    NpcPlaceRelation["ORIGIN"] = "origin";
})(NpcPlaceRelation || (NpcPlaceRelation = {}));
export var Pronouns;
(function (Pronouns) {
    Pronouns["HE_HIM"] = "he/him";
    Pronouns["SHE_HER"] = "she/her";
    Pronouns["THEY_THEM"] = "they/them";
})(Pronouns || (Pronouns = {}));
export const PRONOUNS_FORMS = {
    [Pronouns.HE_HIM]: { subject: 'he', object: 'him', possessive: 'his', reflexive: 'himself' },
    [Pronouns.SHE_HER]: { subject: 'she', object: 'her', possessive: 'her', reflexive: 'herself' },
    [Pronouns.THEY_THEM]: { subject: 'they', object: 'them', possessive: 'their', reflexive: 'themselves' },
};
export function getPronounsGuide() {
    return Object.entries(PRONOUNS_FORMS)
        .map(([label, f]) => `${label}: ${f.subject}, ${f.object}, ${f.possessive}, ${f.reflexive}`)
        .join('\n');
}
export function getPronounsOptions() {
    return Object.values(Pronouns).join(', ');
}
export function getNpcReputationOptions() {
    return Object.values(NpcReputation).join(', ');
}
export function getNpcCharacterRelationOptions() {
    return Object.values(NpcCharacterRelation).join(', ');
}
export function getNpcPlaceRelationOptions() {
    return Object.values(NpcPlaceRelation).join(', ');
}
